import { createApp } from "vue";
import App from "./App.vue";
import "./index.css";
import store from "./store";
// import axiosConfig from "./plugins/axiosConfig";
import VueSSE from "vue-sse";
import router from "./routes";
import ToastPlugin from "vue-toast-notification";
import "vue-toast-notification/dist/theme-bootstrap.css";

const app = createApp(App);

app.use(router);
app.use(store);

// app.use(axiosConfig, {
//   baseUrl: "http://localhost:8080",
// });
app.use(ToastPlugin);
app.use(VueSSE, {
  format: "json",
  polyfill: true,
  withCredentials: true,
});

app.mount("#app");
